import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UITextInput from 'UIComponents/input/UITextInput';
import UISection from 'UIComponents/section/UISection';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TestIds from '../constants/testIDs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "CodeEntryForm__StyledDiv",
  componentId: "sc-19a8v9n-0"
})(["width:40%;min-width:200px;"]);
export default function CodeEntryForm(props) {
  return /*#__PURE__*/_jsx(UISection, {
    children: /*#__PURE__*/_jsxs(StyledDiv, {
      children: [/*#__PURE__*/_jsx(UIFormLabel, {
        htmlFor: "two-factor-code",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reAuth.codeForm.enterCodeLabel"
        })
      }), /*#__PURE__*/_jsx(UITextInput, {
        autoFocus: true,
        id: "two-factor-code",
        onChange: props.onChange,
        value: props.code,
        "data-test-id": TestIds.CODE_ENTRY_BOX
      })]
    })
  });
}